export const backendUrl = `https://zo-obc.azurewebsites.net`;

export default backendUrl
